// src/components/AdminLoginDialog.jsx
import React, { useState } from 'react';
import {
    Box, Button, Dialog, DialogActions, DialogContent, DialogTitle,
    TextField, Typography, Alert
} from '@mui/material';
import { adminLogin } from '../utils/api';

export default function AdminLoginDialog({ open, onClose, onSuccess }) {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [submitting, setSubmitting] = useState(false);
    const [error, setError] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (submitting) return;
        setSubmitting(true);
        setError('');
        try {
            await adminLogin(username.trim(), password);
            onSuccess?.();
            setUsername('');
            setPassword('');
        } catch (err) {
            setError(err?.message || 'Login failed');
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <Dialog
            open={open}
            onClose={submitting ? undefined : onClose}
            aria-labelledby="admin-login-title"
            fullWidth
            maxWidth="xs"
        >
            <DialogTitle id="admin-login-title">Administration Login</DialogTitle>
            <DialogContent>
                <Typography variant="body2" sx={{ mb: 2 }} color="text.secondary">
                    This login is for Historical Society personnel only.
                </Typography>

                {error && (
                    <Alert severity="error" role="alert" aria-live="assertive" sx={{ mb: 2 }}>
                        {error}
                    </Alert>
                )}

                <Box component="form" id="admin-login-form" onSubmit={handleSubmit} noValidate>
                    <TextField
                        label="Username"
                        name="username"
                        autoComplete="username"
                        fullWidth
                        required
                        margin="dense"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        inputProps={{ 'aria-label': 'Username' }}
                        autoFocus
                        disabled={submitting}
                    />
                    <TextField
                        label="Password"
                        name="password"
                        type="password"
                        autoComplete="current-password"
                        fullWidth
                        required
                        margin="dense"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        inputProps={{ 'aria-label': 'Password' }}
                        disabled={submitting}
                    />
                </Box>
            </DialogContent>
            <DialogActions sx={{ px: 3, pb: 2 }}>
                <Button onClick={onClose} disabled={submitting}>Cancel</Button>
                <Button type="submit" form="admin-login-form" variant="contained" disabled={submitting}>
                    {submitting ? 'Signing in…' : 'Sign In'}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
